module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"explainTitle":"Explain The reason","likelihood":"Likelihood","magnitude":"Magnitude"},"de":{"explainTitle":"Erklären Sie den Grund","likelihood":"Wahrscheinlichkeit","magnitude":"Magnitude"}}')
  delete Component.options._Ctor
}
